<div class="info-header" [ngClass]="{ expanded: expanded }">
  <div class="info-header__left">
    <button class="info-header__left__back-button" (click)="goBack()">
      <span class="material-icons">keyboard_arrow_left</span>Back
    </button>
    <h2>
      <span *ngIf="data.rush" class="rush-badge">
          <span class="material-icons rush-badge__icon">schedule</span>
          Rush Request
        </span>
      {{"Project ID: " + data.projectOrderId}}
    </h2>
  </div>
  <div class="info-header__right">
    <button
      class="info-header__right__request"
      (click)="toggleSpecialRequestModal()"
      *ngIf="data.specialQuoteRequirements"
    >
      <span class="material-icons">assignment</span>Project Requirements
    </button>
    <button
      *ngIf="enableSubmitAllBids"
      class="info-header__right__atp"
      (click)="toggleSubmitAllBidsModal()"
    >
      <span class="material-icons">gavel</span>Submit All Bids
    </button>
    <button
      *ngIf="enableAcceptAllOffers"
      class="info-header__right__atp"
      (click)="toggleAcceptAllOfferedProposalModal()"
    >
      <span class="material-icons">fact_check</span>Accept All Offers
    </button>
    <button
      *ngIf="showAtp"
      class="info-header__right__atp"
      (click)="generateATP()"
    >
      <span class="material-icons">login</span>Sign Award
    </button>
  </div>
</div>

<signatp-dialog
  [atpDocumentPath]="atpDocumentPath"
  [active]="signAtpActive"
  [address]="address"
  (modalClosed)="toggleATPModal()"
  [ngClass]="{ 'documents-dialog--active': signAtpActive }"
  [modalHeaderTitle]="childModalHeaderTitle"
  [modalBody]="childModalBody"
  (signedAtpEvent)="signATP($event)"
  (declineAtpEvent)="declineATP($event)"
/>

<allbids-dialog
  [data]="data"
  [active]="allBidsActive"
  [documents]="documents"
  [address]="address"
  [numberOfBids]="numberOfBids"
  (modalClosed)="toggleSubmitAllBidsModal()"
  [ngClass]="{ 'documents-dialog--active': allBidsActive }"
/>

<project-special-request-dialog
  [active]="specialRequestToggle"
  [projectName]="'Project ID: ' + data.projectOrderId"
  [specialQuoteRequirements]="data.specialQuoteRequirements"
  (closeDialog)="toggleSpecialRequestModal()"
/>

<accept-offered-proposal-dialog
  [active]="acceptAllOffersActive"
  [data]="data"
  [multiple]="true"
  (modalClosed)="toggleAcceptAllOfferedProposalModal()"
  [ngClass]="{ 'documents-dialog--active': acceptAllOffersActive }"
/>
